import app from 'flarum/forum/app';
//import HomeBlogCore from 'flarum/core/forum/components/HomeBlog';
import HomeBlogCore from './HomeBlogCore';
import FeaturedBlogItem from 'flarum/v17development/blog/components/FeaturedBlogItem';
import icon from 'flarum/common/helpers/icon';
import { slug } from '../../common';

// Make translation calls shorter
const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.home.blog`;

export default class HomeBlog extends HomeBlogCore {
	get titleText() {
		return (
            t(`${prfx}.title`)
				//{icon('far fa-bullhorn')} Blog
		);
	}

	listItem(article) {
		const defaultImage = app.forum.attribute('blogDefaultImage')
			? `url(${
					app.forum.attribute('baseUrl') +
					'/assets/' +
					app.forum.attribute('blogDefaultImage')
			  })`
			: null;

		return (
			<li key={article.id()} data-id={article.id()}>
				<FeaturedBlogItem article={article} defaultImage={defaultImage} />
			</li>
		);
	}

	get baseClass() {
		return 'FlarumBlogOverview HomeBlog';
	}

	get button() {
		return null;
	}
}
